import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
//   width: 300,
  borderRadius: 25,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 25,
    backgroundColor: theme.palette.mode === 'light' ? '#c0e730' : '#308fe8',
  },
}));

export default function CustomizedProgressBars() {
  return (
    <Stack spacing={2} sx={{ flexGrow: 1 }} >
      <br />
      <h1 className='skills-heading' id='html'>HTML<span>5</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={88} />
      <h2 className='label'>88%</h2>
      <a href='#html' className='icons'><i class='bx bxl-html5'></i></a>

      <h1 className='skills-heading'>CSS</h1>
      <BorderLinearProgress className='bar' variant="determinate" value={80} />
      <h2 className='label'>80%</h2> 
      <a href='#html' className='icons'><i class="fa-brands fa-css3-alt"></i></a>

      <h1 className='skills-heading'>Bootstrap</h1>
      <BorderLinearProgress className='bar' variant="determinate" value={80} />
      <h2 className='label'>80%</h2>
      <a href='#html' className='icons'><i class="fa-brands fa-bootstrap"></i></a>

      <h1 className='skills-heading'>Mongo<span>DB</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={50} />
      <h2 className='label'>50%</h2>
      <a href='#html' className='icons'><i class='bx bxl-mongodb'></i></a>

      <h1 className='skills-heading'>Express <span>JS</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={50} />
      <h2 className='label'>50%</h2>
      <a href='#html' className='icons'><i class="fa-brands fa-js"></i></a>

      <h1 className='skills-heading'>React <span>JS</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={80} />
      <h2 className='label'>80%</h2>
      <a href='#html' className='icons'><i class='bx bxl-react'></i></a>

      <h1 className='skills-heading'>Node <span>JS</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={50} />
      <h2 className='label'>50%</h2>
      <a href='#html' className='icons'><i class="fa-brands fa-node"></i></a>

      <h1 className='skills-heading'>Costumer <span>Sales & Support</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={80} />
      <h2 className='label'>80%</h2>
      <a href='#html' className='icons' style={{width:"10%",fontSize:"6.5rem", borderRadius:"100%"}}><i class="fa-solid fa-headset"></i></a>

      <h1 className='skills-heading'>Computer <span>Basic</span></h1>
      <BorderLinearProgress className='bar' variant="determinate" value={90} />
      <h2 className='label'>90%</h2>
      <a href='#html' className='icons' style={{width:"10%",fontSize:"6.5rem", borderRadius:"100%"}}><i class="fa-solid fa-computer"></i></a>

    </Stack>
  );
}